const optionsAvailable = {};
const optionsTest = Object.defineProperties
(
	{},
	{
		'capture':
		{
			get:function(){optionsAvailable.capture = true;}
		},
		'once':
		{
			get:function(){optionsAvailable.once = true;}
		},
		'passive':
		{
			get:function(){optionsAvailable.passive = true;}
		},
	}
);

document.addEventListener
(
	'',
	function callback()
	{
		document.removeEventListener('',callback,optionsTest);
	},
	optionsTest
);

export default function eventOptions(value)
{
	if(value.once && !optionsAvailable.once)
	{
		console.error('An event handler has been registered with the option: once = true, but once is not supported.');
	}

	if(Object.keys(optionsAvailable).length === 0)
	{
		return !!value.capture;
	}
	else
	{
		return value;
	}
}